/**
 * 🔴🔴 US-AIV2-0041 vòng 2 (review #871 · M1 + LOW-1) — **MỘT nguồn** cho phép cạo chuỗi người dùng tự gõ.
 *
 * Trước file này, `cleanTitle` tồn tại ở **hai bản chép nguyên văn** (`col-equal.binding.ts` và
 * `exp-f-noalloc.binding.ts`). §3.8 *"reuse, không cơ chế thứ hai"*: một bản vá phải làm hai chỗ, và trang thứ ba sẽ
 * chép bản nào nó thấy trước. Đây là chỗ đó — thêm trang mới thì `import`, đừng chép.
 *
 * ## Vì sao phải cạo, và nó đi tới đâu
 *
 * Chuỗi này đi vào `collections.title` / `expenses.name`, vào **payload outbox** ⇒ **thông báo đẩy cho MỌI thành
 * viên** (`expense.handlers.ts`), và vào **PDF sổ** (`report-pdf.loader.ts`). *Một ký tự đảo chiều đủ để dòng thông
 * báo đọc ra một số tiền khác* — đây là họ **Trojan Source (CVE-2021-42574)**, không phải lý thuyết.
 *
 * ## 🔴 BA HỌ, không phải một (review #871 M1a — người rà đo trên DB thật)
 *
 * Bản cũ chỉ cạo họ **embedding/override** `U+202A–202E`. Đo `expenses.name` sau khi ghi, các ký tự sau **SỐNG SÓT**:
 * `U+2066` LRI · `U+2067` RLI · `U+2069` PDI (**họ isolate**) · `U+061C` ALM · `U+2060` WJ.
 * Họ **isolate** làm đúng việc mà họ override làm, chỉ bằng cơ chế mới hơn — cạo một họ mà bỏ họ kia là khoá cửa
 * trước rồi mở cửa sau.
 *
 * ## 🔴🔴 VÌ SAO DỰNG REGEX TỪ BẢNG MÃ, KHÔNG VIẾT LITERAL — bài học trả giá ngay trong lượt vá này
 *
 * Bản đầu của file này viết thẳng `/[U+202A-U+202E…]/`. Sau khi ghi đĩa, dãy escape **bị chuẩn hoá thành CHÍNH CÁC KÝ
 * TỰ VÔ HÌNH ĐÓ**, và trong lúc chuyển đã **đánh rơi** `U+2060` + `U+2066-U+2069`. Đo được: `cleanUserText` khi ấy cạo
 * `202E/061C/200B` nhưng **KHÔNG** cạo `2066/2067/2069/2060` — tức đúng lỗ M1a báo, **vẫn nguyên**, trong chính bản vá
 * M1a. Và không nhìn thấy được khi đọc diff: các ký tự ấy **vô hình theo định nghĩa**.
 *
 * ⇒ Một file phòng thủ Trojan Source **không được chứa ký tự Trojan Source ở dạng literal**. Bảng dưới là **số**, nên
 * nó đọc được, diff được, và không công cụ nào chuẩn hoá mất. `user-text.test.ts` khoá từng mã một.
 */

/**
 * Các khoảng mã bị loại, dạng `[đầu, cuối]` (bao gồm hai đầu). Thêm một họ mới ⇒ thêm một dòng **có chú thích tên**.
 * KHÔNG viết ký tự thật vào đây — xem docblock.
 */
export const AI_USER_TEXT_STRIP_RANGES: readonly (readonly [number, number])[] = Object.freeze([
  [0x0000, 0x001f], // ký tự điều khiển C0
  [0x007f, 0x007f], // DEL
  [0x061c, 0x061c], // ALM — dấu hướng Ả Rập
  [0x200b, 0x200f], // ZWSP · ZWNJ · ZWJ · LRM · RLM
  [0x2060, 0x2060], // WJ — nối từ vô hình
  [0x202a, 0x202e], // LRE · RLE · PDF · LRO · RLO (embedding/override)
  [0x2066, 0x2069], // LRI · RLI · FSI · PDI (isolate)
  [0xfeff, 0xfeff], // BOM / ZWNBSP
]);

const hex4 = (n: number): string => `\\u${n.toString(16).padStart(4, "0")}`;

/** Lớp ký tự dựng TỪ BẢNG MÃ — nguồn regex chỉ chứa chữ số và `\\u`, không chứa ký tự vô hình nào. */
export const AI_USER_TEXT_STRIP_RE = new RegExp(
  `[${AI_USER_TEXT_STRIP_RANGES.map(([a, b]) => (a === b ? hex4(a) : `${hex4(a)}-${hex4(b)}`)).join("")}]`,
  "gu",
);

/** Cạo mọi họ ký tự vô hình/đảo chiều rồi gom khoảng trắng. KHÔNG cắt độ dài — trần là việc của schema biên. */
export function cleanUserText(raw: string): string {
  return raw.replace(AI_USER_TEXT_STRIP_RE, " ").replace(/\s+/g, " ").trim();
}
